import React, { useEffect, useState } from 'react';

const FundingCustomSelect = ({
  label,
  value,
  options = [],
  onChange,
  placeholder = 'Select…',
  themed = false,
}) => {
  const isCustomOption = options[options.length - 1] === 'Custom';
  const presetValues = isCustomOption ? options.slice(0, -1) : options;
  const inPreset = value && presetValues.includes(value);
  const [mode, setMode] = useState(inPreset || !value ? 'select' : 'custom');
  const [customValue, setCustomValue] = useState(inPreset || !value ? '' : value);

  useEffect(() => {
    if (value && !presetValues.includes(value)) {
      setMode('custom');
      setCustomValue(value);
    } else if (value && presetValues.includes(value)) {
      setMode('select');
      setCustomValue('');
    }
  }, [value, presetValues]);

  const handleSelect = (next) => {
    if (next === 'Custom') {
      setMode('custom');
      onChange?.(customValue || '');
      return;
    }
    setMode('select');
    setCustomValue('');
    onChange?.(next);
  };

  const selectValue = inPreset ? value : (mode === 'custom' ? 'Custom' : '');
  const selectClassName = themed
    ? 'fg-application-select'
    : 'h-10 w-full rounded-xl border border-[var(--fg-line)] bg-white px-3 text-sm';
  const inputClassName = themed
    ? 'fg-application-input mt-2'
    : 'mt-2 h-10 w-full rounded-xl border border-[var(--fg-line)] bg-white px-3 text-sm';

  return (
    <div className={themed ? 'fg-create-field' : undefined}>
      {label ? (
        <label className={themed ? 'fg-create-field-label mb-1 block' : 'mb-1 block text-xs font-medium text-[var(--fg-muted)]'}>
          {label}
        </label>
      ) : null}
      <select
        value={selectValue}
        onChange={(e) => handleSelect(e.target.value)}
        className={selectClassName}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      {mode === 'custom' ? (
        <input
          type="text"
          value={customValue}
          onChange={(e) => {
            setCustomValue(e.target.value);
            onChange?.(e.target.value);
          }}
          placeholder="Enter custom value"
          className={inputClassName}
        />
      ) : null}
    </div>
  );
};

export default FundingCustomSelect;
